'use client';

import { createContext, useState, type PropsWithChildren } from 'react';

export const ScrollableContext = createContext<{
  isScrolledVertically: boolean;
  setIsScrolledVertically: (isScrolledVertically: boolean) => void;
} | null>(null);

export const ScrollableWrapper = ({ children }: PropsWithChildren) => {
  const [isScrolledVertically, setIsScrolledVertically] = useState(false);

  return (
    <ScrollableContext.Provider
      value={{ isScrolledVertically, setIsScrolledVertically }}
    >
      {children}
    </ScrollableContext.Provider>
  );
};
